import router from "@/router";
import store from "@/store";
export default {
  install(Vue) {
    Vue.prototype.$logout = async () => {
      if (
        store.state.logged.data &&
        store.state.logged.data.isento_cassino
      ) {
        //? Endpoint de logout do jogador isento
        await Vue.prototype.$axios
          .get("/player/user/exemptLogout")
          .then((resp) => {
            store.commit("setNotification", {
              msg: resp.data.messages,
              color: "success"
            });
          })
          .catch(() => {});
      }

      localStorage.setItem("auth", false);
      store.commit("setLogged", {
        status: false,
        data: {},
      });
      store.commit("setCash", "");
      store.commit("setBonus", "");
      store.commit("setUserTimeLimit", "");
      if (Vue.prototype.$isAgent()) {
        store.commit("setOperators", {});
      }

      localStorage.removeItem("tokenExpirationDate");
      localStorage.removeItem("alertActivateTwoStepsAuthentication");

      if (Vue.prototype.$isAgent()) {
        const operator = localStorage.getItem("operator_auth");
        const auth = localStorage.getItem("auth");
        if (auth !== "true") {
          router.push({
            path: `/page/login/auth/${operator}`,
          });
        }
      } else {
        if (!window.location.pathname.includes("casino/lobby")) {
          router.go();
        }
      }
    };
  },
};
